import { c as _c } from "react/compiler-runtime";
import React from "react";
const LocationFillIcon = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_5103_8391)"><path d="M7 0C5.60818 0.00184628 4.27389 0.555562 3.28973 1.53973C2.30556 2.52389 1.75185 3.85818 1.75 5.25C1.75 9.01906 6.64125 13.7397 6.84906 13.9388C6.88948 13.978 6.94363 14 7 14C7.05637 14 7.11052 13.978 7.15094 13.9388C7.35875 13.7397 12.25 9.01906 12.25 5.25C12.2482 3.85818 11.6944 2.52389 10.7103 1.53973C9.7261 0.555562 8.39182 0.00184628 7 0ZM7 7.65625C6.52409 7.65625 6.05887 7.51513 5.66316 7.25072C5.26745 6.98632 4.95904 6.61052 4.77692 6.17083C4.59479 5.73115 4.54714 5.24733 4.63999 4.78056C4.73283 4.3138 4.962 3.88504 5.29852 3.54852C5.63504 3.212 6.0638 2.98283 6.53056 2.88999C6.99733 2.79714 7.48115 2.84479 7.92083 3.02691C8.36052 3.20904 8.73632 3.51745 9.00072 3.91316C9.26513 4.30887 9.40625 4.77409 9.40625 5.25C9.40587 5.88806 9.15223 6.49988 8.70105 6.95105C8.24988 7.40223 7.63806 7.65587 7 7.65625Z" fill="#4B4B4B" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">{t0}<defs><clipPath id="clip0_5103_8391"><rect width="14" height="14" fill="white" /></clipPath></defs></svg></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default LocationFillIcon;